<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div class="Redeem">
    <div class="Redeem__img">
    </div>
    <div class="Redeem__form" :style="{
      height: isConcert('heroes') ? '574px' : 'auto',
    }">
      <div class="Redeem__form__container">
        <div class="Redeem__form__padding">
          <div class="Redeem__form__info">
            <span v-if="$route.name === 'dieci-milioni-customer'" v-html="$t('received_code_c')" />
            <span v-if="$route.name === 'dieci-milioni-prospect'" v-html="$t('received_code_p')" />
          </div>
          <input type="text" v-model="ticket_id">
          <div class="Redeem__form__detail" v-if="false">
            ({{ $t('code_info') }})
          </div>
          <span class="tokBtn" @click="redeemTicket">
            {{ $t('activate') }}
          </span>
          <!--<router-link class="Redeem__form__needHelp" :to="faqRoute">{{ $t('need_help') }}</router-link>-->
          <a href="/faq-eni" target="_blank" class="Redeem__form__needHelp">{{ $t('need_help') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapActions,
  mapState,
  mapMutations,
  mapGetters,
} from 'vuex';
import get from 'lodash.get';

export default {
  name: 'Redeem',
  data() {
    return {
      ticket_id: '',
    };
  },
  methods: {
    ...mapMutations(['initModal', 'closeRedeem']),
    ...mapActions(['appReady', 'getMe', 'getPlans', 'playVideoById', 'loadTheVideo']),
    isConcert(name) {
      return this.$store.state.singleV === this.$store.state.concertMap[name];
    },
    redeemSuccess() {
      this.initModal({
        display: true,
        title: this.$t('valid_code'),
        text: this.$t('valid_code_text'),
        cta: this.$t('close'),
        callback: 'closeRed',
        animation: 'tada',
      });
    },
    redeemTicket() {
      if (!this.ticket_id) {
        this.initModal({
          display: true,
          title: this.$t('error'),
          text: this.$t('BLANK_REDEEAM_CODE'),
          cta: this.$t('close'),
          callback: 'close',
          animation: 'tada',
        });
        return;
      }
      const that = this;
      this.api.post('/claim-plan',
        {
          type: 'ticket',
          ticket_sku: that.redeem.offers[0],
          ticket_id: that.ticket_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-tok-token': that.getToken,
          },
        })
        .then((response) => {
          // console.log(response);
          if (response.data.valid) {
            that.getMe()
              .then(() => {
                that.closeRedeem();
                if (that.redeem.play === true) {
                  that.playVideoById(that.redeem);
                  const postRedeemRoute = get(that, 'redeem.postRedeemRoute', '/');
                  that.$router.push(postRedeemRoute);
                }
                if (that.redeem.load === true) {
                  that.loadTheVideo(that.redeem);
                  that.$router.push('/home');
                }
                this.redeemSuccess();
              });
          } else {
            that.closeRedeem();
            that.initModal({
              display: true,
              title: this.$t('error'),
              text: this.$t('wrong_code'),
              cta: this.$t('close'),
              callback: 'close',
              animation: 'tada',
            });
            that.ticket_id = '';
          }
        })
        .catch(() => {
          that.initModal({
            display: true,
            title: this.$t('error'),
            text: 'Payment processing error',
            cta: this.$t('close'),
            callback: 'close',
            animation: 'tada',
          });
        });
    },
  },
  computed: {
    ...mapState(['api', 'availablePlans', 'redeem', 'conf', 'env']),
    ...mapGetters(['getToken', 'faqRoute']),
  },
};
</script>

<style scoped lang="scss">
.Redeem {
  background-size: cover;
  background-position: bottom center;
  width: 100%;
  min-height: 100vh;
  position: relative;
  left: 0;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-top: 70px;
  &__img{
    img{
      margin: 0 auto;
      display: block;
      max-width: 90%;
      padding-bottom: 50px;
    }
  }
  &__form {
    background-color: #191919;
    padding: 0;
    // height: 574px;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    width: 100%;
    max-width: 773px;
    margin: 20px;
    border: 1px solid white;
    align-items: center;

    &__img{
      width: 100%;
    }

    &__container {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    &__padding {
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 30px;
      width: fit-content;
      margin: 0 auto;
    }

    &__info {
      color: #ffffff;
      font-size: 22px;
      text-align: center;
      margin-bottom: 40px;
    }

    &__detail {
      color: #ffffff;
      text-align: center;
      font-size: 14px;
      margin-bottom: 20px;
    }

    &__noCode {
      text-align: center;
      color: #611518;
      margin-top: 40px;
      border-bottom: 1px solid #611518;
      padding-bottom: 5px;
      margin-bottom: 5px;
    }

    &__buyTicket {
      text-align: center;
      color: #000;
      text-decoration: underline;
    }

    &__needHelp {
      display: flex;
      flex: auto;
      color: #fff;
      text-decoration: underline;
      align-items: flex-end;
      justify-content: center;
      margin-top: 30px;
    }

    label {
      color: rgba(255, 255, 255, 0.8);
      margin-bottom: 5px;
      text-align: center;
    }

    input {
      margin-bottom: 20px;
      padding: 8px;
      border-radius: 5px;
      border: 1px solid #000;
      font-size: 16px;
      background-color: rgba(255, 255, 255, 1);
      color: #000;
    }

    .tokBtn {
      margin-top: 20px;
      // background-color: #611518;
      // color: white;
      border: 1px solid white;
      height: 40px;
    }
  }
}
</style>
